export const CHANGE_DRAWER_STATE = 'CHANGE_DRAWER_STATE';

export function changeDrawerState() {
  return {
    type: CHANGE_DRAWER_STATE
  };
}




// WEBPACK FOOTER //
// ./src/redux/actions/drawerActions.js